import { HTTP } from '@/API/base/client'

/**
 * Posts to auth API with credential arguments
 * @param  {String} email               Account email
 * @param  {String} password            User password
 * @param  {String} [captchaResponse]   Optional Captcha response from 3rd party script, required only after multiple failed attempts
 * @return {Response}                   200 response
 */
export const signInWithCredentials = (email, password, captchaResponse) => {
  if (!email || !password) {
    return {}
  }
  return HTTP.post('/careers/auth/login', {
    email,
    password,
    captcha_response: captchaResponse,
  })
}

/**
 * Posts to auth API with profile arguments
 * @param  {Object} signUpFields        Object containing fields to sign up for an account
 * @return {Response}                   201 response
 */
export const signUp = (signUpFields = {}) => {
  if (!Object.keys(signUpFields).length) {
    return {}
  }

  return HTTP.post('/careers/auth/signup', signUpFields)
}

/**
 * Posts to auth API to log out user
 * @return {Response}                   200 response
 */
export const signOut = () => {
  return HTTP.post('/careers/auth/logout')
}

/**
 * Deletes the user account
 * @return {Response}                   200 response
 */
export const deleteAccount = () => {
  return HTTP.delete('/careers/auth/delete')
}

/**
 * Posts to auth API to send reset password email
 * @param  {String} email               Account email
 * @return {Response}                   200 response
 */
export const requestResetPassword = (email) => {
  if (!email) {
    return {}
  }

  return HTTP.post('/careers/auth/password/send-reset-password-email', { email })
}

/**
 * Posts to auth API to confirm password reset with new password
 * @param  {String} password            New password
 * @param  {String} token               One-time token to reset password
 * @param  {String} userId              User ID to reset password for
 * @return {Response}                   204 response
 */
export const confirmResetPassword = (password, token, userId) => {
  if (!password || !token || !userId) {
    return {}
  }

  return HTTP.post('/careers/auth/password/confirm', { new_password: password, token, uid: userId })
}

/**
 * Posts to auth API to verify email
 * @param  {String} email               Account email
 * @param  {String} token               Email verification token
 * @return {Response}                   200/204 response
 */
export const verifyEmail = (userId, token) => {
  if (!userId || !token) {
    return {}
  }
  return HTTP.post('/careers/auth/verify-email', { user_id: userId, verification_token: token })
}
